export const CURRENCY_CENTS_COUNT = 100;
export const CURRENCY_CODE = '₪';
